import { Box, Typography } from '@mui/material';
import { Fragment } from 'react';

import { Link } from '@/containers';

import { useLpBreadcrumbs } from './useLpBreadcrumbs';

export const LpBreadcrumbs = () => {
  const crumbs = useLpBreadcrumbs();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: { xs: 1, sm: 2 },
      }}>
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;

        return (
          <Fragment key={crumb.label}>
            {index > 0 && (
              <Typography variant="body3SemiBold" sx={{ color: 'text.light' }}>
                /
              </Typography>
            )}
            {crumb.to && !isLast ? (
              <Link to={crumb.to} textVariant="body3SemiBold" color="text.main">
                {crumb.label}
              </Link>
            ) : (
              <Typography variant="body3SemiBold">{crumb.label}</Typography>
            )}
          </Fragment>
        );
      })}
    </Box>
  );
};
